import { COLORS } from "shared/consts";
import styled from "styled-components";

const BaseWrap = styled.div`
    position: fixed;
    /* ЖЁСТКО фиксируем все стороны */
    top: 0;
    left: 0;
    right: auto;
    bottom: 0;

    /* Панель всегда прижата слева к вьюпорту */
    width: 320px;
    height: 100dvh;             /* было: calc(100dvh - 56px) */
    z-index: 1001;              /* было: 11 — поднимем над шапкой и оверлеем */
    overflow-y: auto;
    border-right: 1px solid ${COLORS.BORDER.SOFT};
    background: ${COLORS.BG.PAGE};

    display: flex;
    flex-direction: column;

    /* На всякий: исключаем влияние трансформаций предков (если что-то повлияет через UA-бага) */
    transform: none;
`;

export const AnimatedWrap = styled(BaseWrap)`
    &.hud-slide-enter {
        transform: translateX(-100%);
    }
    &.hud-slide-enter-active {
        transform: translateX(0);
        transition: transform 300ms ease;
    }
    &.hud-slide-exit {
        transform: translateX(0);
    }
    &.hud-slide-exit-active {
        transform: translateX(-100%);
        transition: transform 300ms ease;
    }
`;

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    left: 0;
    top: 0;
    z-index: 1000; /* должен быть ниже панели, выше контента */

    background: var(--static-black, rgba(16, 24, 40, 1));
    opacity: 0.3;

    &.hud-fade-enter {
        opacity: 0;
    }
    &.hud-fade-enter-active {
        opacity: 0.3;
        transition: opacity 200ms ease;
    }
    &.hud-fade-exit {
        opacity: 0.3;
    }
    &.hud-fade-exit-active {
        opacity: 0;
        transition: opacity 200ms ease;
    }
`;

export const LogoRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    margin-bottom: 4px;

    svg {
        width: 32px;
        height: 32px;
    }
`;
